module.exports = __webpack_public_path__ + "img/type1.57b32f50.png";